export default function initMultipleChoiceCustomFields() {
    document.querySelectorAll('.radiobuttonlist,.checkboxlist').forEach((list) => {
        var inputs = list.querySelectorAll('input[type=radio],input[type=checkbox]');
        inputs?.forEach((input) => {
            input.addEventListener('change', () => {

                // Reset fields
                list.querySelectorAll(`.subfield-${input.id}`)?.forEach((subfield) => {
                    subfield.querySelectorAll('input')?.forEach((i) => {
                        if (i.type == "radio" || i.type == "checkbox"){
                            i.checked = false;
                        }
                        else {
                            i.value = "";
                        }
                    })
                })

                // Hide / show subfield groups
                inputs?.forEach((listInput) => {
                    var group = list.querySelector(`.subfield-group-${listInput.id}`);
                    if (group != undefined){
                        group.style.display = listInput.checked ? '' : 'none';
                    }     
                })

                // Other input field
                inputs.forEach((listInput) => {
                    if (listInput?.classList.contains('custom-input-field')){
                        var inputField = list.querySelector(`.custom-input-field-${listInput.name}`);

                        if (listInput.checked){
                            inputField?.classList.remove('d-none')
                        }
                        else {
                            inputField?.classList.add('d-none')
                        }
                    }
                })
            })
        })
    })
}